import type { IModuleDefinition } from '@platform/core/types';
import type { ILawSource } from './api/ILawSource';
import { LAW_TYPES } from './lawTypes';

/**
 * Джерела моделі закону для законопроєкту типу `rtKey`: типи моделі, що є в модулі й мають поле-посилання на цей тип (перше таке поле).
 * Чиста функція.
 */
export function lawSourcesOf(module: Pick<IModuleDefinition, 'recordTypes'>, rtKey: string): ILawSource[] {
  return LAW_TYPES.flatMap((key) => {
    const child = module.recordTypes.find((r) => r.key === key);
    const ref = child?.fields.find((f) => (f.type === 'ref' || f.type === 'lookup') && f.ref === rtKey);
    return ref ? [{ rt: key, ref: ref.key }] : [];
  });
}
